/**
 * Standard auto loan payment math (amortizing fixed-rate).
 */

export function calcMonthlyPayment(principal, annualAprPercent, termMonths) {
  const p = Math.max(0, Number(principal) || 0);
  const n = Math.max(1, Math.round(Number(termMonths) || 1));
  const r = Math.max(0, Number(annualAprPercent) || 0) / 100 / 12;
  if (p <= 0) return 0;
  if (r === 0) return Math.round(p / n);
  const factor = Math.pow(1 + r, n);
  return Math.round((p * r * factor) / (factor - 1));
}

export function calcTotalInterest(principal, monthlyPayment, termMonths) {
  const p = Math.max(0, Number(principal) || 0);
  const n = Math.max(1, Math.round(Number(termMonths) || 1));
  const m = Math.max(0, Number(monthlyPayment) || 0);
  return Math.max(0, Math.round(m * n - p));
}

export const FINANCE_TERM_OPTIONS = [36, 48, 60, 72, 84];

export const DEFAULT_FINANCE = {
  apr: 6.99,
  termMonths: 72,
  downPayment: 0,
};
